import React from 'react';
import './Home.scss';

export const Home = () => (
  <h1 className="title">Home Page</h1>
);
